import React, {Component} from 'react';
import {BrowserRouter as Router, Route as RouteWithoutLayout, Switch} from 'react-router-dom';

import {Provider} from 'react-redux';
import configureStore from 'store';
import 'typeface-roboto'

import Route from './route';
import Home from './home';
import Profile from './profile';
import Login from './Login';
import Navigation from './Navigation';

const store = configureStore();

var Parse = require('parse');
Parse.initialize(window.__APP_CONFIG__.APP_ID || '')
Parse.serverURL = window.__APP_CONFIG__.SERVER_URL || ''
global.Parse = Parse;

var socket_client = require("socket.io-client");
var socket = socket_client(
	window.__APP_CONFIG__.SERVER_URL.slice(0, window.__APP_CONFIG__.SERVER_URL.lastIndexOf("/")),
	{
		path: `${window.__APP_CONFIG__.SERVER_URL.slice(window.__APP_CONFIG__.SERVER_URL.lastIndexOf("/"))}/socket.io`,
		transports: ['websocket'],
		secure: true
	}
);

socket.on(
	"connect",
	function () {
		socket.emit('socket-room', "rwmanila-cms");
	}
);

global.socket = socket;

export default class App extends Component {

	componentWillMount() {}

	render() {

		const options = {
			position: 'top right',
			timeout: 5000,
			offset: '30px',
			transition: 'scale'
		}

		return (<Provider store={store} id="app">
			<Router>
				<Switch>
					<RouteWithoutLayout path="/login" component={Login}/>
					<RouteWithoutLayout path="/" component={Navigation}/>
				</Switch>
			</Router>
		</Provider>);
	}
}



// WEBPACK FOOTER //
// ./components/app.js